import { FC, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import useToggle from 'react-use/lib/useToggle'
import { ShowMoreBtn } from '@/components/ShowMoreBtn/ShowMoreBtn'
import styles from './CourseDescription.module.scss'

type CourseDescriptionProps = {
  description: string
  collapsible?: boolean
}
export const CourseDescription: FC<CourseDescriptionProps> = ({ description, collapsible }) => {
  const { t, i18n } = useTranslation()
  const [collapseDescription, toggleCollapseDescription] = useToggle(true)

  const truncatedDescription = useMemo(() => {
    if (!collapseDescription || !collapsible) {
      return description
    }

    const truncatedDescLength = 70
    const spaceIndex = description.lastIndexOf(' ', truncatedDescLength) || truncatedDescLength
    return description.substring(0, spaceIndex)
  }, [collapseDescription, collapsible, description])

  const isRTL = i18n.dir() === 'rtl'

  return (
    <section className={styles.description}>
      <p dir={!isRTL ? 'auto' : undefined}>
        {truncatedDescription}
        {collapsible && (
          <ShowMoreBtn
            collapsedText={t('courseDetails.showMore')}
            uncollapsedText={t('courseDetails.hide')}
            collapsed={collapseDescription}
            onClick={toggleCollapseDescription}
          />
        )}
      </p>
    </section>
  )
}
